var _g, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScrollUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_534_17167)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 56.25C36.9619 56.25 43.6387 53.4844 48.5616 48.5616C53.4844 43.6387 56.25 36.9619 56.25 30C56.25 23.0381 53.4844 16.3613 48.5616 11.4384C43.6387 6.51562 36.9619 3.75 30 3.75C23.0381 3.75 16.3613 6.51562 11.4384 11.4384C6.51562 16.3613 3.75 23.0381 3.75 30C3.75 36.9619 6.51562 43.6387 11.4384 48.5616C16.3613 53.4844 23.0381 56.25 30 56.25ZM30 60C37.9565 60 45.5871 56.8393 51.2132 51.2132C56.8393 45.5871 60 37.9565 60 30C60 22.0435 56.8393 14.4129 51.2132 8.7868C45.5871 3.16071 37.9565 0 30 0C22.0435 0 14.4129 3.16071 8.7868 8.7868C3.16071 14.4129 0 22.0435 0 30C0 37.9565 3.16071 45.5871 8.7868 51.2132C14.4129 56.8393 22.0435 60 30 60Z",
    fill: "#006241"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.75 15.9844C31.1851 15.9844 31.6024 16.1572 31.9101 16.4649C32.2178 16.7726 32.3906 17.1899 32.3906 17.625V47.1562C32.3906 47.5914 32.2178 48.0087 31.9101 48.3163C31.6024 48.624 31.1851 48.7969 30.75 48.7969C30.3149 48.7969 29.8976 48.624 29.5899 48.3163C29.2822 48.0087 29.1094 47.5914 29.1094 47.1562V17.625C29.1094 17.1899 29.2822 16.7726 29.5899 16.4649C29.8976 16.1572 30.3149 15.9844 30.75 15.9844Z",
    fill: "#006241"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5866 13.1822C29.739 13.0294 29.92 12.9082 30.1194 12.8255C30.3187 12.7428 30.5324 12.7002 30.7482 12.7002C30.964 12.7002 31.1776 12.7428 31.377 12.8255C31.5763 12.9082 31.7573 13.0294 31.9097 13.1822L41.7535 23.0259C42.0615 23.334 42.2346 23.7518 42.2346 24.1875C42.2346 24.6232 42.0615 25.041 41.7535 25.3491C41.4454 25.6571 41.0276 25.8302 40.5919 25.8302C40.1562 25.8302 39.7384 25.6571 39.4304 25.3491L30.7482 16.6636L22.066 25.3491C21.7579 25.6571 21.3401 25.8302 20.9044 25.8302C20.4687 25.8302 20.0509 25.6571 19.7429 25.3491C19.4348 25.041 19.2617 24.6232 19.2617 24.1875C19.2617 23.7518 19.4348 23.334 19.7429 23.0259L29.5866 13.1822Z",
    fill: "#006241"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_534_17167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollUp);
export default __webpack_public_path__ + "static/media/scroll_up.0841219fb941478de7bff7b99f577c30.svg";
export { ForwardRef as ReactComponent };